import { convertArrayToCSV } from 'convert-array-to-csv'
import { saveAs } from 'file-saver'

const CSV_BOM = '\uFEFF'

// Semicolon matches the backend's shared format=csv handler and opens
// correctly in Excel with Swedish locale settings.
export const CSV_SEPARATOR = ';'

export const createCsvBlob = (data: object[], header?: string[]): Blob => {
  const csv = convertArrayToCSV(data, { header, separator: CSV_SEPARATOR })
  return new Blob([CSV_BOM, csv], { type: 'text/csv;charset=utf-8;' })
}

export const downloadCsv = (
  data: object[],
  filename: string,
  header?: string[]
): void => {
  saveAs(createCsvBlob(data, header), filename)
}
